import { z } from 'zod';
import { ERROR_MESSAGES } from '~/constants/errorMessages';

const DEA_NUMBER_REGEX = /^[A-Z]{2}\d{7}$/;
export const DEA_LICENSE_NOTES_MAX = 128;

export const DeaLicenseFormSchema = z
  .object({
    id: z.number(),
    activeFlag: z.boolean(),
    deaNum: z.string().min(1, { message: ERROR_MESSAGES.REQUIRED }).regex(DEA_NUMBER_REGEX, {
      message: 'Must be two uppercase letters followed by seven digits (e.g. AB1234567)',
    }),
    stateCode: z.string().max(2, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(2)).optional(),
    schedule: z.string().max(32, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(32)).optional(),
    expiryDate: z.iso.date(ERROR_MESSAGES.INVALID_DATE),
    issueDate: z.iso.date(ERROR_MESSAGES.INVALID_DATE),
    licenseNotes: z
      .string()
      .max(DEA_LICENSE_NOTES_MAX, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(DEA_LICENSE_NOTES_MAX)),
    restrictedUseFlag: z.boolean(),
    providerId: z.number().optional(),
    validFlag: z.boolean().optional(),
    warnings: z.record(z.string(), z.string()).optional(),
  })
  .refine(
    (data) => {
      if (!data.activeFlag) return true;
      const now = new Date();
      const todayISO = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      return data.expiryDate > todayISO;
    },
    {
      message: 'License cannot be active if already expired',
      path: ['expiryDate'],
    }
  )
  .refine((data) => data.expiryDate > data.issueDate, {
    message: ERROR_MESSAGES.INVALID_DATE_ORDER('Issue Date', 'Expiration Date'),
    path: ['expiryDate'],
  });

export type DeaLicenseFormValues = z.infer<typeof DeaLicenseFormSchema>;
